import { Modal } from "components/modal/modal";
import React from "react";
import Image from "next/legacy/image";
import {
  TrialActivationStatusContainer,
  TrialActivationStatusDesc,
  TrialActivationStatusImage,
  TrialActivationStatusTitle
} from "./trial-activation-modal.styles";
import { ITrialActivationStatus } from "./trial-activation-modal.types";
import { TrialActivationStatusData } from "./trial-activation-modal.data";
import { Spacer } from "styles/common/spacer";
import { Button } from "components/atoms/button/button";
import { ModalSize } from "components/modal/modal.types";
import { useRouter } from "next/router";

const TrialActivationStatus: React.FC<ITrialActivationStatus> = ({
  activationState,
  daysLeft,
  onClose
}) => {
  const closeIconProperties = {
    isHidden: true
  };
  const router = useRouter();
  const statusData = TrialActivationStatusData[activationState];

  const handleActionButtonClick = () => {
    onClose();
    statusData.actionButtonClick(router);
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      size={ModalSize.Narrow}
      closeIconProperties={closeIconProperties}
    >
      <TrialActivationStatusContainer>
        <TrialActivationStatusImage>
          <Image
            src={statusData.imgSrc}
            alt={statusData.alt}
            layout="intrinsic"
          />
        </TrialActivationStatusImage>
        <Spacer token={[8, 8, 8]} />
        <TrialActivationStatusTitle>
          {statusData.title(daysLeft ? daysLeft : null)}
        </TrialActivationStatusTitle>
        <Spacer token={[8, 8, 8]} />
        <TrialActivationStatusDesc>{statusData.desc}</TrialActivationStatusDesc>
        <Spacer token={[24, 24, 24]} />
        <Button variant="primary" onClick={handleActionButtonClick}>
          {statusData.actionButtonText}
        </Button>
      </TrialActivationStatusContainer>
    </Modal>
  );
};

export { TrialActivationStatus };
